import "./index.scss";
import { Spin, message } from "antd";
import { useEffect } from "react";
import userApi from "../../apis/index";
import { setCallbackUrl } from "../../unit";
import { LoadingOutlined } from '@ant-design/icons';
import { projectCode } from "../../setting.js";

const MenuLoadingPage = (props) => {
  const { setPageLoading } = props;

  const getMenus = () => {
    userApi.getMenus().then((res) => {
      if (res.code === 200) {
        const menusItem = res?.data?.find((_) => _.menu_code === projectCode);
        if (!menusItem) {
          // message.error('未匹配到本项目的目录数据!');
          setCallbackUrl(window.location.href)
          //没订阅过 跳到详情页
          window.location.href = localStorage.getItem("sub_url");
          return;
        }
      } else {
        message.error(res.msg);
      }
      setPageLoading(false)
    });
  };

  useEffect(() => {
    getMenus();
  },[]);

  return (
    <Spin
      className="mySpinLoading"
      tip={props.tip}
      // indicator={
      //   <LoadingOutlined spin />
      // }
      size="large"
    ></Spin>
  );
};
export default MenuLoadingPage;
